export default __webpack_public_path__ + "static/media/Dina.f4b8bbf6.png";